<template>
  <div class="empty">
    <div class="empty-icon"></div>
    <p class="empty-title text-primary">No data available</p>
    <p class="empty-subtitle">
      There is no component available: {{ componentName }}
    </p>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {};
    },
  },
});
// Safely access __component with optional chaining to prevent runtime errors
const componentName = props.content?.__component || 'unknown';
</script>
